// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shipment-section[data-v-578a9c64]{margin-top:75px}", ""]);
// Exports
module.exports = exports;
